import { Type } from 'class-transformer';
import { Corretor } from './corretor';

export class BrokerList {
  @Type(() => Corretor) diretores: Corretor[];
  @Type(() => Corretor) corretores: Corretor[];
}
